<div class="flex items-center gap-x-2">

    <app-button
        #benefitsButton
        [color]="buttonColor"
        [disabled]="benefits.isAnimating()"
        [label]="'Benefits'"
        [active]="benefits.showContainer()"
        (event)="benefits.toggleContainer()"
    />

</div>